import { BikeModel } from "./bikeModel";
import { Station } from "./station";
import { PublicTariffPlan, TariffPlan } from "./tariffPlan.interface";

export interface Bike {
    bikeId: string;
    code: number | string;
    progressive: string;
    description?: string;
    // lat?: number;
    // lng?: number;
    currentStation?: string;
    status: string;
    model?: string
    currentStationDetails?: Station;
    statusDetails?: BikeStatus;
    modelDetails?: BikeModel;
    iotDetails?: BikeIot;
    imei?: string;
    identifier?: string;
    iotStatus?: string;
}

export interface BikeStatus {
    code: number | string;
    description: string;
    color: string;
}

export interface BikeIot {
    location?: {
        lat?: number;
        lng?: number;
        alt?: number;
        accuracy?: number;
        numberOfSatellites?: number;
        lastUpdate?: Date;
        isCloseToArrival?: boolean; // non da backend, a uso interno in home
    };
    bike?: {
        battery?: {
            level?: number;
            status?: string;
        },
        isOn?: boolean;
        speedMode?: string;
        cruiseControl?: boolean;
        startMode?: string;
        lowSpeedLimit?: number;
        mediumSpeedLimit?: number;
        highSpeedLimit?: number;
        throttleResponse?: boolean;
        headlight?: boolean;
        currentSpeed?: number;
        faultCode?: string;
        remainingMileage?: number; // non da backend, a uso interno in home
        rideMileage?: number; // non da backend, a uso interno in home
        lastUpdate?: Date;
    };
    iot?: {
        networkSignal?: number;
        errorCode?: string;
        lastUpdate?: Date;
    };
    lock?: {
        battery?: {
            level?: number;
            voltage?: number;
        },
        isLocked?: boolean;
        lockChangeTimestamp?: Date
    };
    active?: boolean
}

export interface PublicBike {
    bikeId: string;
    code: number | string;
    progressive: string;
    description?: string;
    currentStation?: string;
    status: string;
    model?: string
    currentStationDetails?: Station;
    statusDetails?: BikeStatus;
    modelDetails?: BikeModel;
    iotDetails?: BikeIot;
    imei?: string;
    identifier?: string;
    iotStatus?: string;
    tariffPlans?: PublicTariffPlan[]
}

export interface BikeFilter {
    options: {
        status: any[],
        currentStation: any[],
        model: any[]
    },
    cache: {
        status: any[],
        currentStation: any[],
        model: any[]
    },
    values: {
        status?: string,
        currentStation?: string,
        model?: string
    },
    applied: {
        status?: string,
        currentStation?: string,
        model?: string
    }
}

export function getDefaultBike(): Bike {
    return structuredClone({
        bikeId: '',
        code: '',
        progressive: '',
        lat: 0,
        lng: 0,
        status: "AVAILABLE",
        currentStation: undefined,
    })
}